/**
 * `SubscriptionGiftDto` and friends, from docs/booking-api.swagger.json.
 *
 * A gift is a membership plan someone bought for someone else. It sits unassigned
 * until an admin attaches it to a real user account.
 */

export interface GiftBuyer {
  id: string;
  firstName: string | null;
  lastName: string | null;
  completeName: string | null;
  email: string | null;
  phoneNumber: string | null;
  avatar: string | null;
}

export interface GiftPlan {
  id: string;
  internalName: string | null;
  nameEn: string | null;
  nameEs: string | null;
}

/** `SubscriptionGiftStatus` — enum [0, 1, 2]. */
export const GIFT_STATUS = {
  pending: 0,
  assigned: 1,
  failed: 2,
} as const;

export interface SubscriptionGift {
  id: string;
  createdAt: string | null;
  deletedAt: string | null;
  buyerUserId: string | null;
  subscriptionId: string | null;
  status: number | null;

  recipientFullName: string | null;
  recipientEmail: string | null;
  recipientPhone: string | null;

  /** Set once the gift has been attached to an account. */
  assignedAt: string | null;
  assignedToUserId: string | null;
  assignedById: string | null;
  userSubscriptionId: string | null;

  comments: string | null;
  additionalJsonString: string | null;

  buyer: GiftBuyer | null;
  subscription: GiftPlan | null;
}

/** `PagedSubscriptionGiftsDto` — `{ total, gifts }`, not `{ count, results }`. */
export interface PagedGifts {
  total: number;
  gifts: SubscriptionGift[];
}
